const productsBrowserFacetsWrapper = () => ({
  isSpecialOpen: false,
  filterCollectionsCache: {},
  isFiltersDrawerOpen: false,

  get appliedFilters() {
    /**
     * Expected Object Structure
     * {
     *  "p.m.category": ['Bags', 'Shoes'],
     *  "p.m.color": ['Black', 'Blue']
     * }
     * Output
     * [
     *   { field: "p.m.category", value: "Bags" },
     *   { field: "p.m.category", value: "Shoes" },
     *   { field: "p.m.color", value: "Black" },
     *   { field: "p.m.color", value: "Blue" },
     * ]
     */
    const appliedFilters = Object.entries(this.activeFacets).reduce((acc, facet) => {
      // key = p.m.category & value = ['Bags', 'Shoes']
      acc.push(
        ...Object.values(facet[1])
          .filter((value) => value !== '')
          .map((value) => ({ field: facet[0], value })),
      );
      return acc;
    }, []);
    return appliedFilters;
  },

  get facetCount() {
    return this.appliedFilters.length;
  },

  handleMobileOpen() {
    this.isFiltersDrawerOpen = true;
  },

  handleMobileClose() {
    this.isFiltersDrawerOpen = false;
  },

  async applyFacets() {
    // updates things in parent context

    const newActiveFacets = this.activeFacets;
    const newSort = this.sort;
    await this.$nextTick();
    this.activeFacets = newActiveFacets;
    this.sort = newSort;

    this.isFiltersDrawerOpen = false;
  },

  async clearAllFacets() {
    // updates activeFacets in parent context

    this.activeFacets = this.getEmptyFacets();
    await this.$nextTick();
    this.applyFacets();
  },

  handleMobileToggleSpecial() {
    this.isSpecialOpen = !this.isSpecialOpen;
  },
});

export default productsBrowserFacetsWrapper;
